import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { getDescriptionByCurrentPayment } from 'modules/PaymentsPage/__data'

import { selectLanguage } from 'features/userSettings/selectors'

import './DescriptionBlock.scss'

const b = block('description-block')

export const DescriptionBlock: React.FC<{ paymentKey: string }> = ({ paymentKey }) => {
  const lang = useSelector(selectLanguage, shallowEqual)

  const descriptionData = useMemo(() => getDescriptionByCurrentPayment({ lang, paymentKey }), [lang, paymentKey])

  if (!descriptionData.__html) return null

  return (
    <div className={b()}>
      <div dangerouslySetInnerHTML={descriptionData} className={b('text')} />
    </div>
  )
}
